const todos = [
  {
    id: 1,
    title: 'Grab Black Friday Sales',
    date: '2019-12-23',
    time: '23:30',
    comment: '',
    completed: false,
    important: false,
    isEditMode: false,
  },
  {
    id: 2,
    title: 'Learn Redux or Hook',
    date: '',
    time: '',
    comment: 'https://www.reddit.com/r/reactjs/comments/ap614g/new_to_react_should_i_learn_redux/',
    completed: false,
    important: false,
    isEditMode: false,
  },
  {
    id: 3,
    title: 'Watch Bohemian Rhapsody',
    date: '',
    time: '',
    comment: '',
    completed: true,
    important: false,
    isEditMode: false,
  },
  {
    id: 4,
    title: 'Buy new MacBook Pro without touch bar',
    date: '2020-03-30',
    time: '',
    comment: '🙈🍎💻',
    completed: false,
    important: true,
    isEditMode: false,
  },
  {
    id: 5,
    title: 'BBQ in wilderness',
    date: '',
    time: '15:00',
    comment: 'Make new recipe: mixed leaf & orange salad',
    completed: true,
    important: false,
    isEditMode: false,
  },
];

export default todos;
